// @fluentui/react-focus@7.1.13
// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
import { setVersion } from '@uifabric/set-version';
setVersion('@fluentui/react-focus', '7.1.13');